/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener('load', () => {
  const zenDeskPlaceholder = document.querySelector('.zendesk-placeholder');
  if (zenDeskPlaceholder) {
    zenDeskPlaceholder.style.display = 'block';
  }

  // If on "SizeSwatchList" el exists, and only has one child, click that child (e.g. onesize)
  const sizeSwatchList = document.querySelector('.SizeSwatchList');

  if (sizeSwatchList && sizeSwatchList.children.length === 1) {
    sizeSwatchList.children[0].querySelector('label').click();
  }
});

function chatLoadChecker() {
  if ($('iframe#launcher').contents().length > 0) {
    zE(function () {
      zE.activate();
    });
    $('.zendesk-placeholder').remove();
  } else {
    setTimeout(chatLoadChecker, 100);
  }
}

function loadZendeskWidget() {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'ze-snippet';
  script.async = true;
  script.src = 'https://static.zdassets.com/ekr/snippet.js?key=26653fd9-b14a-431e-95e0-ef9dec1aa986';
  document.getElementsByTagName('head')[0].appendChild(script);
}

let target = document.querySelector('.zendesk-placeholder__container');

if (target) {
  target.addEventListener('click', (event) => {
    loadZendeskWidget();
    chatLoadChecker();
  });
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.searchIcon = document.querySelector('.search-icon-wrapper');

    this.input = this.querySelector('input[type="search"]');

    this.searchOverlay = document.querySelector('.search-overlay');
    if (this.searchOverlay) {
      this.overlayCloseButton = this.searchOverlay.querySelector('.close-button');
      this.overlaySearchInput = this.searchOverlay.querySelector('input[type="search"]');
    }
    // this.isMobile = this.classList.contains('is-mobile');
    this.resultsTotal = 0;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    if (this.searchIcon) this.searchIcon.addEventListener('click', this.openSearchOverlay.bind(this));
    if (this.overlayCloseButton) this.overlayCloseButton.addEventListener('click', this.closeSearchOverlay.bind(this));

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      const closeSearch = !this.contains(document.activeElement) &&
        !event.target.closest('predictive-search') &&
        !event.target.closest('#predictive-search-results-wrapper') &&
        !event.target.closest('#predictive-search-results') &&
        !event.target.closest('.search-overlay');

      if (closeSearch) {
        this.close();
      }
    });
  }

  getResultsCount(searchTerm) {
    fetch(`/search?q=${searchTerm}&type=product`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        let parser = new DOMParser();
        let fetchedPage = parser.parseFromString(text, "text/html");
        if (fetchedPage.querySelector('#regularSearchResults')) {
          this.resultsTotal = fetchedPage.querySelector('#regularSearchResults').innerHTML;
          const totalCountTarget = document.querySelector('#totalCountTarget');
          if (!totalCountTarget) return;
          totalCountTarget.innerHTML = this.resultsTotal;
        }

      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&section_id=predictive-search&resources[limit]=6&resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultMarkupWrapper = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        const predictiveSearchResultsWrapper = document.querySelector('#predictive-search-results-wrapper');
        const predictiveSearchContainer = resultMarkupWrapper.querySelector('#predictive-search-results');

        if (predictiveSearchContainer.querySelector('.grid-search-results') !== null) {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          predictiveSearchResultsWrapper.innerHTML = resultsMarkup;
          this.getResultsCount(searchTerm);
          this.open();
          window.yotpoWidgetsContainer.initWidgets();
          const event = new CustomEvent('predictive-search:updated');
          document.dispatchEvent(event);
        }
        else {
          this.closeLight();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.removeAttribute('open');
  }

  closeLight() {
    this.removeAttribute('open');
    if (document.body.classList.contains('overflow-hidden')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  openSearchOverlay() {
    if (this.searchOverlay) {
      document.body.classList.add('no-scroll');
      this.searchOverlay.classList.add('search-visible');
      this.overlaySearchInput.focus();
    }
  }

  closeSearchOverlay() {
    if (this.searchOverlay) this.searchOverlay.classList.remove('search-visible');
    document.body.classList.remove('no-scroll');
    this.closeResults(false);
  }

  closeResults(clearSearchTerm) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    if (!this.isMobile) this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onDocumentClick(event) {
    const isOnOverlayBackground = event.target === this.searchOverlay ||
      event.target.classList.contains('search-overlay');

    if (this.searchOverlay?.classList.contains('search-visible') && isOnOverlayBackground) {
      this.closeSearchOverlay();
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);

const mobileFilterButton = document.querySelector('.CollectionToolbar__Item--filter');
const mobileFilterDrawer = document.getElementById('collection-filter-drawer');

if (mobileFilterDrawer && mobileFilterButton) {
  const overlay = document.querySelector('.PageOverlay');
  const htmlEl = document.querySelector('html');
  const closeButton = mobileFilterDrawer.querySelector('.Drawer__Close');

  function toggleDrawer(method) {
    const isDrawerHidden = mobileFilterDrawer?.getAttribute('aria-hidden') === 'true' ? true : false;

    if (method === 'close') {
      mobileFilterDrawer?.setAttribute('aria-hidden', 'true');  
      overlay?.classList.remove('is-visible');
      htmlEl?.classList.remove('no-scroll');
      return;
    }

    if (isDrawerHidden) {
      mobileFilterDrawer?.setAttribute('aria-hidden', 'false');
      overlay?.classList.add('is-visible');
      htmlEl?.classList.add('no-scroll');
    } else {
      mobileFilterDrawer?.setAttribute('aria-hidden', 'true');
      overlay?.classList.remove('is-visible');
      htmlEl?.classList.remove('no-scroll');
    }
  }

  closeButton?.addEventListener('click', toggleDrawer);
  mobileFilterButton?.addEventListener('click', toggleDrawer);
  overlay?.addEventListener('click', toggleDrawer('close'));
}

let pendingCartRecommendationsProductId = null;

function loadCartRecommendations(productId) {
  // The quick-add UI needs the ALL_VARIANTS catalog, which loads in the
  // background across several paginated requests. Rendering before it is
  // ready would throw mid-loop and leave the upsell wrapper stuck hidden,
  // so defer until loadAllProducts dispatches ALL_VARIANTS:loaded.
  if (window.ALL_VARIANTS === undefined) {
    if (pendingCartRecommendationsProductId === null) {
      document.addEventListener('ALL_VARIANTS:loaded', () => {
        const pendingProductId = pendingCartRecommendationsProductId;
        pendingCartRecommendationsProductId = null;
        loadCartRecommendations(pendingProductId);
      }, { once: true });
    }
    pendingCartRecommendationsProductId = productId;
    return;
  }

  fetch(window.routes.productRecommendationsUrl + `?section_id=product-recommendations&product_id=${productId}` + "&limit=8")
    .then((response) => {
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
      const wrapper = resultsMarkup.querySelector('.ProductRecommendations');
      if (wrapper == undefined) return;

      const items = wrapper.querySelectorAll('.ProductItem.AppendWishlistBtn');
      if (items === undefined) return;

      const upsellCartWrapper = document.querySelector('.Upsell__Cart__Wrapper');
      if (upsellCartWrapper === null) return;
      const existingUpsellCart = upsellCartWrapper.querySelector('.Upsell__Cart');
      if (existingUpsellCart) existingUpsellCart.remove();
      upsellCartWrapper.classList.remove('show');

      const upsellCart = document.createElement('div');
      upsellCart.classList.add('Upsell__Cart');
      upsellCartWrapper.appendChild(upsellCart);

      if (items.length > 0) {
        items.forEach((item, index) => {
          item.setAttribute('data-index', index);
          upsellCart.appendChild(item);

          const addedItem = document.querySelector(`.ProductItem[data-index="${index}"]`);

          if (!addedItem) {
            console.warn("Upsell item does not exist in the DOM", addedItem);
            return;
          }

          const apiProductVariants = (window.ALL_VARIANTS || []).filter((variant) => variant.product_id === parseInt(addedItem.dataset.productId));

          if (!apiProductVariants) {
            return;
          }

          if (apiProductVariants.length == 0) {
            return;
          }
          
          let productItemWrapper = addedItem.querySelector('.ProductItem__Wrapper');

          const select = document.createElement('select');
          select.classList.add('ProductItem__Select');
          select.setAttribute('name', 'id');
          select.setAttribute('data-variant-id', addedItem.dataset.variantId);
          select.setAttribute('data-product-id', addedItem.dataset.productId);
          select.setAttribute('data-quantity', 1);

          apiProductVariants.forEach((variant) => {
            const option = document.createElement('option');
            option.setAttribute('value', variant.id);
            option.textContent = variant.variant_title;
            select.appendChild(option);
          });

          if (productItemWrapper) {
            const button = document.createElement('button');
            button.classList.add('ProductItem__AddToCart');
            button.setAttribute('type', 'submit');
            button.setAttribute('data-variant-id', apiProductVariants[0].id);
            button.setAttribute('data-product-id', apiProductVariants[0].product_id);
            button.textContent = window.languages.cartUpsellButton ?? 'Add';

            const productItemQuickAdd = document.createElement('div');
            productItemQuickAdd.classList.add('ProductItem__QuickAdd');
            productItemQuickAdd.appendChild(select);
            productItemQuickAdd.appendChild(button);
            productItemWrapper.appendChild(productItemQuickAdd);
          } else {
            console.warn("Upsell item does not have a ProductItem__Info div", addedItem);
          }
        })
      }

      // Setup events for the select and quick add button
      const selects = upsellCart.querySelectorAll('.ProductItem__Select');
      const buttons = upsellCart.querySelectorAll('.ProductItem__AddToCart');

      selects.forEach((select) => {
        select.addEventListener('change', (event) => {
          const variantId = event.target.value;
          const productId = event.target.dataset.productId;
          const quantity = event.target.dataset.quantity;
          const button = select.parentElement.querySelector('.ProductItem__AddToCart');
          button.setAttribute('data-variant-id', variantId);
          button.setAttribute('data-product-id', productId);
          button.setAttribute('data-quantity', quantity);
        });
      });

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const variantId = event.target.getAttribute('data-variant-id');
          const productId = event.target.getAttribute('data-product-id');

          const form = new FormData();
          form.append('id', variantId);
          form.append('quantity', 1);

          fetch('/cart/add.js', {
            method: 'POST',
            body: form
          }).then((response) => {
            if (response.ok) {
              const event = new CustomEvent('product:added', {
                detail: {
                  variant: {
                    id: variantId,
                    product_id: productId
                  },
                  quantity: 1
                }
              });
              document.dispatchEvent(event);
            }
          });
        });
      });

      // const config = { attributes: true, childList: true, subtree: true };
      const options = {
        freeScroll: false,
        adaptiveHeight: false,
        pageDots: false,
        percentPosition: false,
        setGallerySize: true,
        contain: true,
        cellAlign: 'left',
        initialIndex: '.is-initial-selected',
        prevNextButtons: true
      };

      const flkty = new Flickity(upsellCart, options);
      upsellCartWrapper.classList.add('show');
    })
    .then(() => {
      // const event = new CustomEvent('cart-upsell:updated');
      // document.dispatchEvent(event);
    })
    .then(() => {
      //reinit yotpo widget star ratings
      // window.yotpoWidgetsContainer?.initWidgets();
    })
    .catch((error) => {
      // A throw anywhere above leaves the upsell wrapper without its .show
      // class (invisible) — surface it instead of failing silently.
      console.error('Cart recommendations failed to render:', error);
    })
}

function refreshCartRecommendations() {
  fetch(window.routes.cartUrl + ".js").then(function (response) {
    if (response.ok) {
      response.json().then((cartData) => {
        // Guard against an empty cart (no first item) to avoid throwing.
        if (!cartData.items || cartData.items.length === 0) return;
        loadCartRecommendations(cartData.items[0].product_id);
      })
    }
  });
}

document.addEventListener('product:added', function (event) {
  const productId = event.detail.variant.product_id;
  loadCartRecommendations(productId);
});

window.addEventListener('load', () => {
  // Bind to every element that opens the cart drawer, not just the first
  // .Cart-icon (which can be hidden on desktop), so recommendations load
  // whenever the cart is opened — not only after an add-to-cart.
  const cartTriggers = document.querySelectorAll('.Cart-icon, [data-drawer-id="sidebar-cart"]');
  cartTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      refreshCartRecommendations();
    });
  });

  // Every 1000ms, check if there is a product recommendation in the cart, if not refresh them
  setInterval(() => {
    const sidebarCart = document.querySelector('#sidebar-cart');
    if (!sidebarCart) return;

    const isOpen = sidebarCart.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    const upsellCartWrapper = document.querySelector('.Upsell__Cart__Wrapper');
    if (upsellCartWrapper) {
      const upsellCart = upsellCartWrapper.querySelector('.Upsell__Cart');
      if (upsellCart) {
        const items = upsellCart.querySelectorAll('.ProductItem.AppendWishlistBtn');
        if (items.length === 0) {
          console.log("REFRESHING RECOS");
          refreshCartRecommendations();
        }
      }
    }
  }, 2000);

  // Every 500ms check if a line item of type bundle is in the cart, to ensure the right info is shown
  setInterval(() => {
    if (!window.ALL_PRODUCTS) return;
    const cartItems = [...document.querySelectorAll('.CartItem:not(.checked)')];

    cartItems.forEach((item) => {
      item.classList.add('checked');

      try {
        const meta = item.querySelector('.CartItem__Meta');
        const metaBundleData = meta.getAttribute("data-bundle-data");

        if (metaBundleData != null && metaBundleData.length != "") {
          const bundleVariantIds = JSON.parse(meta.getAttribute("data-bundle-data"));
          const elementsToAdd = [];

          bundleVariantIds.forEach((variantId) => {
            const variant = window.ALL_PRODUCTS.find((variant) => variant.id === parseInt(variantId));
            if (variant) {
              const pElement = document.createElement('p');
              pElement.classList.add('CartItem__Variant');
              pElement.textContent = `${variant.title} - ${variant.variant_title}`;
              elementsToAdd.push(pElement);
            }
          });

          if (elementsToAdd.length > 0) {
            meta.innerHTML = "";

            elementsToAdd.forEach((element) => {
              meta.appendChild(element);
            });
          }
        }
      }
      catch (err) {
        console.error(err);
      }
    });
  }, 500);

  // Every 500ms, check if count is "NaN" and refresh the cart
  setInterval(() => {
    const cartDot = document.querySelector('.Header__CartDot');
    if (!cartDot) {
      return;
    }

    if (cartDot.textContent != "NaN") {
      return;
    }

    fetch(window.routes.cartUrl + ".js").then(function (response) {
      if (response.ok) {
        response.json().then((cartData) => {
          const cartCount = cartData.item_count;
          cartDot.textContent = cartCount;
        })
      }
    });
  }, 500);
});

async function loadAllProducts() {
  const templateSuffix = "json-bb";
  const collectionHandle = "all";

  const allProducts = [];
  let page = 1;
  let hasMoreProducts = true;
  let loopCount = 0;

  while (hasMoreProducts && loopCount < 10) {
    loopCount++;

    try {
      const response = await fetch(`/collections/${collectionHandle}?view=${templateSuffix}&page=${page}`, {
        type: "GET",
      });

      const json = await response.json();

      if (json.products.length > 0) {
        allProducts.push(...json.products);
        page++;
      } else {
        hasMoreProducts = false;
      }

    } catch (error) {
      hasMoreProducts = false;
    }
  }

  window.ALL_VARIANTS = allProducts;
  const variantsLoadedEvent = new CustomEvent("ALL_VARIANTS:loaded", {})
  document.dispatchEvent(variantsLoadedEvent)
}

class LowInStockVariants extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productJsonScript = document.querySelector(
      "script[data-product-json]"
    );
    this.lowInventoryLabel = this;
    this.variantRadios = document.querySelectorAll("input[name='option-0']");

    if (
      !this.productJsonScript ||
      !this.lowInventoryLabel ||
      !this.variantRadios.length
    ) {
      console.log("Required elements not found.");
      return;
    }

    this.productData = JSON.parse(this.productJsonScript.innerHTML);
    this.inventories = this.productData?.inventories || {};
    this.variants = this.productData?.product?.variants || [];

    this.init();
  }

  init() {
    this.LowInStockMessage();
    this.variantRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.LowInStockMessage(radio);
      });
    });
  }

  LowInStockMessage(radioElement = null) {
    const radio =
      radioElement || [...this.variantRadios].find((r) => r.checked);
    const selectedValue = radio?.value;

    const variant = this.variants.find((v) => v.option1 === selectedValue);

    if (variant && this.inventories[variant.id]) {
      const quantity = this.inventories[variant.id].inventory_quantity;
      const size = variant.option1;

      if (quantity > 0 && quantity < 5) {
        this.lowInventoryLabel.classList.add("show-this");
      } else {
        this.lowInventoryLabel.classList.remove("show-this");
      }
    } else {
      this.lowInventoryLabel.classList.remove("show-this");
    }
  }
}

customElements.define("low-inventory-label", LowInStockVariants);



(function () {
  loadAllProducts().then(() => {
    // console.log("PRODUCTS LOADED: ", window.ALL_VARIANTS);
  });

  function safeInitialize() {
    const addToCartButton = document.querySelector('.ProductForm__AddToCart');
    const productVariantButtons = document.querySelectorAll('.ProductForm__Variants .HorizontalList__Item.SizePicker');

    // Early return if elements don't exist
    if (!addToCartButton) {
      return false;
    }

    if (productVariantButtons.length === 0) {
      return false;
    }

    // Safe event listener attachment
    try {
      productVariantButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (addToCartButton) { 
            addToCartButton.classList.add('variant-selected');
          }
        });
      });

      addToCartButton.addEventListener('click', (event) => {
        setTimeout(() => {
          if (addToCartButton && addToCartButton.classList.contains('variant-selected')) {
            addToCartButton.removeAttribute('disabled');
          }
        }, 1000);
      });

      return true;
    } catch (error) {
      console.error('Error initializing cart functionality:', error);
      return false;
    }
  }

  function initWithRetry() {
    if (safeInitialize()) return;
    
    setTimeout(() => {
      if (safeInitialize()) return;
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(safeInitialize, 100);
        });
      }
    }, 200);
  }

  initWithRetry();
})();

class ProductBundleManager extends HTMLElement {
  constructor() {
    super();

    this.bundleGroups = [...this.querySelectorAll('.ProductMeta__BundleGroup')];
    this.addToCartButton = this.querySelector('.ProductMeta_Bundle__Buttons .ProductForm__Bundle__AddToCart');
    this.moreDetailsButtons = [...this.querySelectorAll('.ProductMeta__BundleGroup__Details')];
    this.popup = this.querySelector('.ProductMeta_Popup__Overlay');
    this.popupCloseButton = this.querySelector('.ProductMeta_Popup__Close');
    this.pageOverlay = document.querySelector('.PageOverlay');

    // Move popup to body so it sits above the header z-index stacking context
    if (this.popup) {
      document.body.appendChild(this.popup);
    }
  }

  connectedCallback() {
    this.setSelectedVariants();
    this.setupBundleGroupEvents();

    this.addToCartButton.addEventListener('click', this.addBundleToCart.bind(this));
    this.moreDetailsButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const parentGroup = button.closest('.ProductMeta__BundleGroup');
        const selectedProduct = parentGroup.querySelector('.ProductMeta__BundleProduct.selected');
        const productId = selectedProduct.dataset.productId;

        if (!selectedProduct) {
          return
        }

        this.popup.querySelector('.ProductMeta_Popup__Title').innerHTML = selectedProduct.dataset.title;
        this.popup.querySelector('.ProductMeta_Popup__Description').innerHTML = selectedProduct.dataset.description;
        this.popup.querySelector('.ProductMeta_Popup__Image').src = selectedProduct.dataset.featuredImage;

        const productAdditionalsDetails = parentGroup.querySelector(`.ProductForm__Bundle__Product__Additionals[data-product-id="${productId}"] .ProductForm__Bundle__Product__Details`);
        console.log(productAdditionalsDetails)
        console.log(productId)
        const popupTabs = this.popup.querySelector('.ProductMeta_Popup__Tabs');

        if (productAdditionalsDetails) {
          popupTabs.display = 'block';
          popupTabs.querySelector('.Collapsible__Content .Rte').innerHTML = productAdditionalsDetails.innerHTML;
          const popupTabsButton = popupTabs.querySelector('.Collapsible__Button');

          if (popupTabsButton) {
            const isOpen = popupTabsButton.getAttribute('aria-expanded') === 'true';
            if (!isOpen) {
              setTimeout(() => {
                popupTabsButton.click();
              }, 200);
            }
          }
        } else {
          popupTabs.display = 'none';
        }

        this.popup.classList.add('show');
        if (this.pageOverlay) this.pageOverlay.classList.add('is-visible');
        document.body.style.top = '-' + window.scrollY + 'px';
        document.body.classList.add('modal-open');
      });
    });

    const closeBundlePopup = () => {
      this.popup.classList.remove('show');
      if (this.pageOverlay) this.pageOverlay.classList.remove('is-visible');
      var scrollY = document.body.style.top;
      document.body.classList.remove('modal-open');
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };

    this.popup.addEventListener('click', (event) => {
      if (event.target === this.popup) {
        closeBundlePopup();
      }
    });

    this.popupCloseButton.addEventListener('click', (event) => {
      closeBundlePopup();
    });

    const sizeGuideOpens = [...this.querySelectorAll('.size-open-popup')];

    sizeGuideOpens.forEach((button) => {
      button.addEventListener('click', (event) => {
        const sizeGuidePopup = button.nextElementSibling;
        sizeGuidePopup.classList.remove('size-overlay-hidden');
      });
    });

    const sizeGuideCloses = [...this.querySelectorAll('.size-close')];

    sizeGuideCloses.forEach((button) => {
      button.addEventListener('click', (event) => {
        const sizeGuidePopup = button.closest('.size-overlay');
        sizeGuidePopup.classList.add('size-overlay-hidden');
      });
    });

    const sizeGuideOverlay = [...this.querySelectorAll('.size-overlay')];

    sizeGuideOverlay.forEach((overlay) => {
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          overlay.classList.add('size-overlay-hidden');
        }
      });
    });
  }

  setupBundleGroupEvents() {
    this.bundleGroups.forEach((group) => {
      const products = [...group.querySelectorAll('.ProductMeta__BundleProduct')];

      products.forEach((product) => {
        const productId = product.dataset.productId;

        product.addEventListener('click', (event) => {
          this.removeAndAddClass(products, product, 'selected');

          const groupIndex = group.dataset.index;
          const productFormOptions = [...group.querySelectorAll('.ProductForm__Bundle__Option')];
          const selectedOption = productFormOptions.find((option) => option.dataset.productId === productId);
          this.removeAndAddClass(productFormOptions, selectedOption, 'selected');
          const variantLabel = group.querySelector(`.ProductMeta__BundleGroup__Variant span`);
          const preview = group.querySelector('.ProductMeta__BundleGroup__Preview');
          const desktopPreviewImages = [...document.querySelectorAll(`.ProductBundle .Product__Gallery .Product__SlideItem[data-group-index="${groupIndex}"]`)];

          if (variantLabel) {
            variantLabel.textContent = product.dataset.color;
          }

          if (preview) {
            preview.querySelector('img').src = product.dataset.featuredImage;
          }

          if (desktopPreviewImages.length > 0) {
            // Remove class show from all and add to selected ones
            desktopPreviewImages.forEach((image) => {
              image.classList.remove('show');
            });

            const selectedImages = desktopPreviewImages.filter((image) => image.dataset.productId === productId);
            selectedImages.forEach((image) => {
              image.classList.add('show');
            });
          }

          const titleEl = group.querySelector('.ProductMeta__BundleGroup__Title');
          if (titleEl) {
            titleEl.textContent = product.dataset.title;
          }

          group.querySelector('.ProductMeta__BundleGroup__Link').href = product.dataset.url;
          this.setSelectedVariants();
          this.validateBundleManager();
        });
      });

      const labels = [...group.querySelectorAll('.ProductForm__Bundle__Option label')];
      labels.forEach((label) => {
        label.addEventListener('click', (event) => {
          const input = label.parentElement.querySelector('input');
          const inputValue = input.value;

          const productOption = label.closest('.ProductForm__Bundle__Option');
          const productId = productOption.dataset.productId;

          const variantAvailable = input.dataset.variantAvailable == 'true' ? true : false;
          const variantId = input.dataset.variantId;

          const bundleGroup = label.closest('.ProductMeta__BundleGroup');
          const productIndex = bundleGroup.dataset.index;

          this.selectedVariants[productIndex].productId = parseInt(productId);
          this.selectedVariants[productIndex].variantId = parseInt(variantId);
          this.selectedVariants[productIndex].variantTitle = inputValue;
          this.selectedVariants[productIndex].variantAvailable = variantAvailable;

          this.validateBundleManager();
        });
      });
    });
  }

  setSelectedVariants() {
    this.selectedVariants = this.bundleGroups.map((_, index) => {
      const selectedBundleProduct = _.querySelector('.ProductMeta__BundleProduct.selected');
      const matchingBundleOption = _.querySelector('.ProductForm__Bundle__Option.selected');

      const productId = selectedBundleProduct?.dataset?.productId ?? null;
      let variantValue, variantId, variantAvailable;

      if (matchingBundleOption) {
        const input = matchingBundleOption.querySelector('input:checked');
        variantValue = input?.value;
        variantId = input?.dataset.variantId;
        variantAvailable = input?.dataset.variantAvailable == 'true' ? true : false;
      }

      return {
        index: index,
        productId: productId ? parseInt(productId) : null,
        variantId: variantId ? parseInt(variantId) : null,
        variantTitle: variantValue ?? null,
        variantAvailable: variantAvailable ?? false
      }
    });
  }

  removeAndAddClass(list, item, className) {
    list.forEach((item) => {
      item.classList.remove(className);
    });

    item.classList.add(className);
  }

  validateBundleManager() {
    const isAllSelected = this.selectedVariants.every((variant) => variant.productId && variant.variantId);
    const inStock = this.selectedVariants.every((variant) => variant.variantAvailable);

    if (isAllSelected && inStock) {
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.textContent = window.languages.bundleAddToCart;
    } else if (isAllSelected) {
      this.addToCartButton.setAttribute('disabled', true);
      this.addToCartButton.textContent = window.languages.bundleOutOfStock;
    } else {
      this.addToCartButton.setAttribute('disabled', true);
      this.addToCartButton.textContent = window.languages.bundleSelectProducts;
    }
  }

  addBundleToCart() {
    const bundleProductVariantId = this.dataset.mainProductVariantId;
    const bundleId = new Date().getTime();
    const bundleItems = this.selectedVariants.map((variant) => variant.variantId);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: bundleProductVariantId,
            quantity: 1,
            properties: {
              _bundleId: bundleId,
              _bundleItems: bundleItems
            }
          }
        ]
      })
    }).then(() => {
      const event = new CustomEvent('product:added', {
        detail: {
          variant: {
            id: bundleProductVariantId,
            product_id: bundleProductVariantId
          },
          quantity: 1
        }
      });

      document.dispatchEvent(event);
    })
  }
}

customElements.define('product-bundle-manager', ProductBundleManager);

class EstimatedDelivery extends HTMLElement {
  constructor() {
    super();

    this.DELIVERY_DAYS = {
      dk: {
        min: 1,
        max: 2
      },
      eu: {
        min: 3,
        max: 6
      },
      de: {
        min: 3,
        max: 6
      },
      us: {
        min: 4,
        max: 7
      },
      co: { // uk
        min: 3,
        max: 6
      },
      com: {
        min: 3,
        max: 6
      },
      fr: {
        min: 3,
        max: 6
      },
      no: {
        min: 1,
        max: 2
      }
    }
    this.TODAY = new Date();
    const CUT_OFF_TIME = 12;
    this.isDateCutOff = new Date(this.TODAY.toLocaleString("en-us", { timeZone: "Europe/Copenhagen" })).getHours() >= CUT_OFF_TIME; // check if it's after 12pm in Denmark (noon)
    this.publicHolidays = this.getPublicHolidays(this.TODAY.getFullYear())

    this.monthFormat = this.getAttribute('month-format');

    this.init();
  }

  init() {
    // Delay message replaces the calculated dates, nothing to compute
    if (this.classList.contains('estimated-delivery--delay')) return;

    const estimatedDeliveryElem = this;
    let country = estimatedDeliveryElem.getAttribute('data-domain').split('.')[1] || 'dk';
    let locale = window.Shopify.locale;

    const estimatedDate = this.isDateCutOff ? this.addDays(this.TODAY, 1) : this.TODAY
    let minDate = this.getDeliveryDate(estimatedDate, this.DELIVERY_DAYS[country].min)
    let maxDate = this.getDeliveryDate(minDate, this.DELIVERY_DAYS[country].max - this.DELIVERY_DAYS[country].min)

      if (minDate && maxDate) {
        console.log(locale)
        this.querySelector('.estimated-delivery__min').innerText = minDate.toLocaleString(this.getToLocaleStringLocale(), this.getToLocaleStringSettings());
        this.querySelector('.estimated-delivery__max').innerText = maxDate.toLocaleString(this.getToLocaleStringLocale(), this.getToLocaleStringSettings());
        estimatedDeliveryElem.classList.remove('hide')
      } else {
        estimatedDeliveryElem.classList.add('hide');
      }
  }

  getToLocaleStringLocale() {
    const domain = this.getAttribute('data-domain');
    const tld = domain.split('.')[1] || 'dk';

    if (tld === 'com') {
      return 'en-US';
    }

    const country = window.Shopify.country;
    
    if (country === 'DK') {
      return 'da-DK';
    }

    if(country === 'DE') {
      return 'de-DE';
    }

    if(country === 'FR') {
      return 'fr-FR';
    }

    if(country === 'GB') {
      return 'en-GB';
    }

    if(country === 'US') {
      return 'en-US';
    }

    return 'en-US';
  }

  getToLocaleStringSettings() {
    return {
      month: 'long',
      day: 'numeric'
    }
  }

  getDeliveryDate(from, to) {
    let deliveryDate = this.addDays(from, to)
    return this.dateAdjust(deliveryDate)
  }

  addDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }

  dateAdjust(date) {
    date = this.adjustForWeekends(date)
    date = this.adjustForPublicHolidays(date)
    return date
  }

  adjustForWeekends(date) {
    if (date.getDay() === 0) { // Sunday
      date = this.addDays(date, 1)
    } else if (date.getDay() === 6) { // Saturday
      date = this.addDays(date, 2)
    }
    return date
  }

  adjustForPublicHolidays(date) {
    if (!this.publicHolidays) {
      return date
    }

    if (date.getFullYear() !== this.TODAY.getFullYear()) {
      this.publicHolidays = [
        ...this.publicHolidays,
        ...this.getPublicHolidays(date.getFullYear())
      ]
    }

    const dateString = this.getDateString(date);
    const isPublicHoliday = this.publicHolidays.find(holiday => holiday.date === dateString)

    return isPublicHoliday
      ? this.dateAdjust(addDays(date, 1))
      : date;
  }

  getDateString(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month < 10
      ? '0' + month
      : month
      }-${day < 10
        ? '0' + day
        : day
      }`
  }

  getPublicHolidays(year) {
    const xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", `https://date.nager.at/api/v3/PublicHolidays/${year}/DK`, false);
    xmlHttp.send(null);
    if (xmlHttp.responseText) {
      return JSON.parse(xmlHttp.responseText);
    } else {
      return [];
    }
  }
}

customElements.define('estimated-delivery', EstimatedDelivery);

document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".video-embedded");
  const playButtons = document.querySelectorAll(".video-embed__play-button");

  function togglePlayPause(currentVideo, currentPlayButton) {
    videos.forEach((video, index) => {
      if (video !== currentVideo && !video.paused) {
        video.pause();
        playButtons[index].style.display = "block";
        video.controls = false;
      }
    });
    const posterContainer = currentVideo.closest('.video-embed__section').querySelector('.poster-container');

    if (currentVideo.paused) {
      currentVideo.play();
      currentPlayButton.style.display = "none";
      currentVideo.controls = true;
    } else {
      currentVideo.pause();
      currentPlayButton.style.display = "block";
    }

    posterContainer.style.display = "none";
  }

  videos.forEach((video, index) => {
    const playButton = playButtons[index];
    video.controls = false;

    playButton.addEventListener("click", () => togglePlayPause(video, playButton));

    video.addEventListener("pause", () => {
      playButton.style.display = "block";
      video.controls = false;
      const posterContainer = video.closest('.video-embed__section').querySelector('#poster-container');
      posterContainer.style.display = "block";
    });

    video.addEventListener("play", () => {
      playButton.style.display = "none";
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('[data-section-type="collection-list"], [data-section-type="featured-collections"], [data-section-type="product-recommendations"]');

  sections.forEach(section => {
    const slider = section.querySelector('.ProductList--carousel');
    if (!slider) return;

    const flickityOptions = JSON.parse(slider.getAttribute('data-flickity-config'));
    const flkty = new Flickity(slider, {
      ...flickityOptions,
      draggable: true
    });

    const previousButton = section.querySelector('.button--previous');
    const nextButton = section.querySelector('.button--next');

    function updateButtonStates() {
      const selectedIndex = flkty.selectedIndex;
      const totalSlides = flkty.slides.length;
      
      if (previousButton) {
        if (selectedIndex === 0) {
          previousButton.disabled = true;
          previousButton.classList.add('is-disabled');
        } else {
          previousButton.disabled = false;
          previousButton.classList.remove('is-disabled');
        }
      }
      
      if (nextButton) {
        if (selectedIndex >= totalSlides - 1) {
          nextButton.disabled = true;
          nextButton.classList.add('is-disabled');
        } else {
          nextButton.disabled = false;
          nextButton.classList.remove('is-disabled');
        }
      }
    }

    if (previousButton && nextButton) {
      previousButton.addEventListener('click', function () {
        flkty.previous();
      });

      nextButton.addEventListener('click', function () {
        flkty.next();
      });

      updateButtonStates();
      flkty.on('change', updateButtonStates);
      flkty.on('settle', updateButtonStates);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const sections = document.querySelectorAll('[data-section-type="product-recommendations"]');
  
    sections.forEach(section => {
      const slider = section.querySelector('.ProductList--carousel');
      if (!slider) return;
 
      const flickityOptions = JSON.parse(slider.getAttribute('data-flickity-config'));
      const flkty = new Flickity(slider, {
        ...flickityOptions,
        draggable: true
      });
 
      const previousButton = section.querySelector('.button--previous');
      const nextButton = section.querySelector('.button--next');

      function updateButtonStates() {
        const selectedIndex = flkty.selectedIndex;
        const totalSlides = flkty.slides.length;
        
        if (previousButton) {
          if (selectedIndex === 0) {
            previousButton.disabled = true;
            previousButton.classList.add('is-disabled');
          } else {
            previousButton.disabled = false;
            previousButton.classList.remove('is-disabled');
          }
        }
        
        if (nextButton) {
          if (selectedIndex >= totalSlides - 1) {
            nextButton.disabled = true;
            nextButton.classList.add('is-disabled');
          } else {
            nextButton.disabled = false;
            nextButton.classList.remove('is-disabled');
          }
        }
      }
 
      if (previousButton && nextButton) {
        previousButton.addEventListener('click', function () {
          flkty.previous();
        });
 
        nextButton.addEventListener('click', function () {
          flkty.next();
        });

        updateButtonStates();
        flkty.on('change', updateButtonStates);
        flkty.on('settle', updateButtonStates);
      }
    });
  }, 1500)
});


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const mobileWrapper = document.querySelector('.ProductListWrapper--mobile');
    if (!mobileWrapper) return;

    const grid = mobileWrapper.querySelector('.ProductList--grid-mobile');
    const cells = grid ? Array.from(grid.querySelectorAll('.ProductList__Grid__Cell')) : [];
    const showMoreBtn = mobileWrapper.querySelector('.ProductList__ShowMore');
    const showLessBtn = mobileWrapper.querySelector('.ProductList__ShowLess');
    const batchSize = 4;

    if (cells.length > batchSize) {
      showMoreBtn.style.display = 'block';
    }

    let visibleCount = batchSize;

    showMoreBtn?.addEventListener('click', function () {
      const nextVisible = Math.min(visibleCount + batchSize, cells.length);
      for (let i = visibleCount; i < nextVisible; i++) {
        cells[i].classList.remove('ProductRecommendations__hidden-mobile');
      }

      // Flickity/lazy load for the newly revealed batch
      setTimeout(() => {
        const newlyVisibleItems = cells.slice(visibleCount, nextVisible);
        newlyVisibleItems.forEach(cell => {
          // Lazy load
          const lazyImages = cell.querySelectorAll('img[data-src]');
          lazyImages.forEach(img => {
            if (window.lazySizes) {
              window.lazySizes.loader.unveil(img);
            }
          });
          // Flickity re-init
          const productCard = cell.querySelector('product-card');
          if (productCard && productCard.initCarousel) {
            const slider = productCard.querySelector('.flickity-carousel');
            if (slider && slider.flickityInstance) {
              slider.flickityInstance.destroy();
            }
            productCard.initCarousel();
          }
        });
        window.dispatchEvent(new Event('resize'));
      }, 100);

      visibleCount = nextVisible;
      if (visibleCount >= cells.length) {
        showMoreBtn.style.display = 'none';
        showLessBtn.style.display = 'block';
      }
    });

    showLessBtn?.addEventListener('click', function () {
      for (let i = batchSize; i < cells.length; i++) {
        cells[i].classList.add('ProductRecommendations__hidden-mobile');
      }
      visibleCount = batchSize;
      showLessBtn.style.display = 'none';
      showMoreBtn.style.display = 'block';
    });
  }, 1500)
});


class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    // setTimeout(() => {
    //   this.initCarousel();
    // }, 500);

    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach(entry => {
    //     if (entry.isIntersecting) {
    //       this.initCarousel();
    //       observer.unobserve(this);
    //     }
    //   });
    // });
    // observer.observe(this);
  }

  initCarousel() {
    const slider = this.querySelector('.flickity-carousel');
    if (!slider) return;

    // Destroy previous Flickity instance if it exists
    if (slider.flickityInstance) {
      slider.flickityInstance.destroy();
    }

    const flickityOptions = JSON.parse(slider.getAttribute('data-flickity-config'));
    const flkty = new Flickity(slider, {
      ...flickityOptions,
      cellAlign: "center",
      contain: false,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.2,
      adaptiveHeight: true
    });

    // Store the Flickity instance for later destruction
    slider.flickityInstance = flkty;

    const arrows = this.querySelector('.ProductItem__HoverImages__Arrows');
    if(arrows) {
      const previousButton = this.querySelector('.button--previous');
      const nextButton = this.querySelector('.button--next');
      if (previousButton && nextButton) {
        previousButton.addEventListener('click', function () {
          flkty.previous();
        });
        nextButton.addEventListener('click', function () {
          flkty.next();
        });
      }
    }
  }
}

customElements.define("product-card", ProductCard);
class Sticky {
  constructor(el) {
    this.element = el;
    this.headerOffset = this.element.offsetTop;
    this.isStuck = false;
    this.lastScrollY = window.scrollY;
    this.classes = {
      stuck: 'js__header__stuck',
    };
    this.attributes = {
      scrollLock: 'data-scroll-lock'
    };

    this._attachListeners();
    this._checkInitialScroll();
  }

  _checkInitialScroll() {
    if (window.scrollY > this.headerOffset) {
      this.stickSimple();
    }
  }

  _attachListeners() {
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll(e) {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > this.lastScrollY;

    if (isScrollingDown) {
      if (!this.isStuck && currentScrollY > this.headerOffset) {
        this.stickSimple();
      }
    } else if (currentScrollY <= this.headerOffset) {
      this.unstickSimple();
    }

    this.lastScrollY = currentScrollY;
  }

  stickSimple() {
    this.element.classList.add(this.classes.stuck);
    this.isStuck = true;
  }

  unstickSimple() {
    if (!document.documentElement.hasAttribute(this.attributes.scrollLock)) {
      this.element.classList.remove(this.classes.stuck);
      this.isStuck = false;
    }
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll.bind(this));
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.Header');
  if (header) {
    window.stickyHeader = new Sticky(header);
  }
});

function showTab(evt, tabId) {
  document.querySelectorAll('.ProductTabs__Panel').forEach(panel => {
    panel.style.display = 'none';
  });

  document.querySelectorAll('.ProductTabs__NavButton').forEach(btn => {
    btn.classList.remove('active');
  });

  document.getElementById(tabId).style.display = 'block';
  evt.currentTarget.classList.add('active');
}

const firstTab = document.querySelector('.ProductTabs__NavButton');
if (firstTab) {
  firstTab.click();
}


function showCollectionTab(evt, tabId) {
  const section = evt.currentTarget.closest('[data-section-type="featured-collections"]');
  if (!section) return;


  section.querySelectorAll('.TabPanel').forEach(panel => {
    panel.setAttribute('aria-hidden', 'true');
  });

  section.querySelectorAll('.TabList__Item').forEach(btn => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-selected', 'false');
  });

  const selectedTab = section.querySelector(`#${tabId}`);
  if (!selectedTab) return;

  selectedTab.setAttribute('aria-hidden', 'false');
  evt.currentTarget.classList.add('is-active');
  evt.currentTarget.setAttribute('aria-selected', 'true');

  const slider = selectedTab.querySelector('.ProductList--carousel');
  if (!slider) return;

  let flkty = slider.flickityInstance;

  if (!flkty) {
    const flickityOptions = JSON.parse(slider.getAttribute('data-flickity-config'));
    flkty = new Flickity(slider, {
      ...flickityOptions,
      draggable: true
    });
    slider.flickityInstance = flkty;

 if (!section.classList.contains('flickity-controls-bound')) {
      const previousButton = section.querySelector('.button--previous');
      const nextButton = section.querySelector('.button--next');

      if (previousButton && nextButton) {
        previousButton.addEventListener('click', () => {
          const activeSlider = section.querySelector('.TabPanel[aria-hidden="false"] .ProductList--carousel');
          activeSlider?.flickityInstance?.previous();
        });

        nextButton.addEventListener('click', () => {
          const activeSlider = section.querySelector('.TabPanel[aria-hidden="false"] .ProductList--carousel');
          activeSlider?.flickityInstance?.next();
        });

        section.classList.add('flickity-controls-bound');
      }
    }
  }
}

// if compare-modal__cards is out of view, show compare-modal__cards-sticky-wrapper
const compareModalCards = document.querySelector('.compare-modal__cards');
const compareModalCardsStickyWrapper = document.querySelector('.compare-modal__cards-sticky-wrapper');

if (compareModalCards) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        compareModalCardsStickyWrapper.style.transform = 'translateY(-100%)';
      } else {
        compareModalCardsStickyWrapper.style.transform = 'translateY(0)';
      }
    });
  });
  observer.observe(compareModalCards);
}

window.addEventListener('load', () => {
  setTimeout(() => {
    const badges = document.querySelectorAll('.ProductItem_BDG_Badge-PDP-Desktop');
    badges.forEach(badge => {
      badge.classList.add('ProductItem_BDG_Badge-PDP-Desktop-Loaded');
    });

    const eaBadges = document.querySelectorAll('.EarlyAccess__PDP-LabelList--desktop');
    eaBadges.forEach(badge => {
      badge.classList.add('EarlyAccess__PDP-LabelList--loaded');
    });
  }, 0);
});

// Country Selector Functionality
// 
// To trigger the country selector from any element, add the data-show-country attribute:
// <button data-show-country>Open Country Selector</button>
// <div data-show-country>Click here to open country selector</div>
//
// The country selector will automatically:
// - Show on page load if geolocation detects user is in a different country
// - Allow manual triggering via data-show-country attribute
// - Use the existing PageOverlay for background overlay
// - Handle all country/language selection and redirection logic
class CountrySelector {
  constructor() {
    this.popUp = document.getElementById('GeoPopUp');
    this.countrySelect = document.getElementById('countrySelect');
    this.languageSelect = document.getElementById('languageSelect');
    this.countrySelectText = document.getElementById('countrySelectText');
    this.languageSelectText = document.getElementById('languageSelectText');
    this.continueButton = document.getElementById('continueButton');
    this.pageOverlay = document.querySelector('.PageOverlay');
    
    // Countries configuration matching the provided list
    this.countries = [
      {
        code: 'AU',
        label: 'Australia',
        currency: 'AUD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'AT',
        label: 'Austria',
        currency: 'EUR',
        languages: [
          { code: 'DE', label: 'German', shop: '.de', market: 'DE' },
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
        ],
      },
      {
        code: 'BE',
        label: 'Belgium',
        currency: 'EUR',
        languages: [
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
          { code: 'DE', label: 'German', shop: '.de', market: 'DE' },
          { code: 'FR', label: 'French', shop: '.fr', market: 'FR' },
        ],
      },
      {
        code: 'BG',
        label: 'Bulgaria',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'CA',
        label: 'Canada',
        currency: 'CAD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'CL',
        label: 'Chile',
        currency: 'CLP',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'CN',
        label: 'China',
        currency: 'CNY',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'HR',
        label: 'Croatia',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'CY',
        label: 'Cyprus',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'CZ',
        label: 'Czech Republic',
        currency: 'CZK',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'DK',
        label: 'Denmark',
        currency: 'DKK',
        languages: [
          { code: 'DA', label: 'Danish', shop: '.dk', market: 'DK' },
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
        ],
      },
      {
        code: 'EE',
        label: 'Estonia',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'FI',
        label: 'Finland',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'FR',
        label: 'France',
        currency: 'EUR',
        languages: [
          { code: 'FR', label: 'French', shop: '.fr', market: 'FR' },
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
        ],
      },
      {
        code: 'DE',
        label: 'Germany',
        currency: 'EUR',
        languages: [
          { code: 'DE', label: 'German', shop: '.de', market: 'DE' },
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
        ],
      },
      {
        code: 'GR',
        label: 'Greece',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'GL',
        label: 'Greenland',
        currency: 'DKK',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'GG',
        label: 'Guernsey',
        currency: 'GBP',
        languages: [{ code: 'EN', label: 'English', shop: '.co.uk', market: 'GB' }],
      },
      {
        code: 'HK',
        label: 'Hong Kong',
        currency: 'HKD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'HU',
        label: 'Hungary',
        currency: 'HUF',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'IS',
        label: 'Iceland',
        currency: 'ISK',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'ID',
        label: 'Indonesia',
        currency: 'IDR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'IE',
        label: 'Ireland',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'IM',
        label: 'Isle of Man',
        currency: 'GBP',
        languages: [{ code: 'EN', label: 'English', shop: '.co.uk', market: 'GB' }],
      },
      {
        code: 'IL',
        label: 'Israel',
        currency: 'ILS',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'IT',
        label: 'Italy',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'JP',
        label: 'Japan',
        currency: 'JPY',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'JE',
        label: 'Jersey',
        currency: 'GBP',
        languages: [{ code: 'EN', label: 'English', shop: '.co.uk', market: 'GB' }],
      },
      {
        code: 'KW',
        label: 'Kuwait',
        currency: 'KWD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'LV',
        label: 'Latvia',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'LT',
        label: 'Lithuania',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'LU',
        label: 'Luxembourg',
        currency: 'EUR',
        languages: [
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
          { code: 'DE', label: 'German', shop: '.de', market: 'DE' },
          { code: 'FR', label: 'French', shop: '.fr', market: 'FR' },
        ],
      },
      {
        code: 'MY',
        label: 'Malaysia',
        currency: 'MYR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'MT',
        label: 'Malta',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'MX',
        label: 'Mexico',
        currency: 'MXN',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'NL',
        label: 'Netherlands',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'NZ',
        label: 'New Zealand',
        currency: 'NZD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'NO',
        label: 'Norway',
        currency: 'NOK',
        languages: [{ code: 'EN', label: 'English', shop: '.no', market: 'NO' }],
      },
      {
        code: 'OM',
        label: 'Oman',
        currency: 'OMR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'PL',
        label: 'Poland',
        currency: 'PLN',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'PT',
        label: 'Portugal',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'QA',
        label: 'Qatar',
        currency: 'QAR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'RO',
        label: 'Romania',
        currency: 'RON',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'SA',
        label: 'Saudi Arabia',
        currency: 'SAR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'SG',
        label: 'Singapore',
        currency: 'SGD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'SK',
        label: 'Slovakia',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'SI',
        label: 'Slovenia',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'ZA',
        label: 'South Africa',
        currency: 'ZAR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'KR',
        label: 'South Korea',
        currency: 'KRW',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'ES',
        label: 'Spain',
        currency: 'EUR',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'SE',
        label: 'Sweden',
        currency: 'SEK',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'CH',
        label: 'Switzerland',
        currency: 'CHF',
        languages: [
          { code: 'EN', label: 'English', shop: '.com', market: 'COM' },
          { code: 'DE', label: 'German', shop: '.de', market: 'DE' },
          { code: 'FR', label: 'French', shop: '.fr', market: 'FR' },
        ],
      },
      {
        code: 'TW',
        label: 'Taiwan',
        currency: 'TWD',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'TH',
        label: 'Thailand',
        currency: 'THB',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'TR',
        label: 'Turkey',
        currency: 'TRY',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'AE',
        label: 'UAE',
        currency: 'AED',
        languages: [{ code: 'EN', label: 'English', shop: '.com', market: 'COM' }],
      },
      {
        code: 'GB',
        label: 'United Kingdom',
        currency: 'GBP',
        languages: [{ code: 'EN', label: 'English', shop: '.co.uk', market: 'GB' }],
      },
      {
        code: 'US',
        label: 'United States',
        currency: 'USD',
        languages: [{ code: 'EN', label: 'English', shop: '.us', market: 'US' }],
      },
    ];

    // Get current store information
    this.currentDomain = window.location.hostname;
    this.currentPath = window.location.pathname;
    this.storeCode = this.getCurrentStoreCode();
    this.selectedCountry = this.countries.find((country) => country.code === this.storeCode);
    this.selectedLanguage = this.selectedCountry?.languages[0];

    if(this.selectedCountry && this.selectedLanguage) {
      this.continueButton?.classList.add('active');
    }

    this.init();
  }

  getCurrentStoreCode() {
    if (this.currentDomain.includes('saysky.dk')) return 'DK';
    if (this.currentDomain.includes('saysky.de')) return 'DE';
    if (this.currentDomain.includes('saysky.fr')) return 'FR';
    if (this.currentDomain.includes('saysky.co.uk')) return 'GB';
    if (this.currentDomain.includes('saysky.us')) return 'US';
    if (this.currentDomain.includes('saysky.no')) return 'NO';
    return 'COM'; // International store (saysky.com)
  }

  init() {
    if (!this.popUp) return;

    this.setupEventListeners();
    this.populateCountrySelect();
    this.populateLanguageSelect(this.selectedCountry?.code);
    this.checkRedirect();
    this.checkGeolocation();
    this.setCountryFlagAndText();
    this.updateSelectorDisplayText();
  }

  setupEventListeners() {
    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', this.handleCountryChange.bind(this));
    }
    if (this.languageSelect) {
      this.languageSelect.addEventListener('change', this.handleLanguageChange.bind(this));
    }
    if (this.continueButton) {
      this.continueButton.addEventListener('click', this.handleConfirm.bind(this));
    }
    if (this.pageOverlay) {
      this.pageOverlay.addEventListener('click', this.handleOverlayClick.bind(this));
    }

    // Listen for elements with data-show-country attribute
    document.addEventListener('click', this.handleShowCountryClick.bind(this));
  }

  handleCountryChange(event) {
    const countryCode = event.target.value;
    this.selectedCountry = this.countries.find((c) => c.code === countryCode);
    this.selectedLanguage = this.selectedCountry?.languages[0];

    this.populateLanguageSelect(countryCode);
    this.updateSelectorDisplayText();
    this.continueButton?.classList.add('active');
  }

  handleLanguageChange(event) {
    const languageCode = event.target.value;
    this.selectedLanguage = this.selectedCountry?.languages.find((l) => l.code === languageCode);
    this.updateSelectorDisplayText();
    this.continueButton?.classList.add('active');
  }

  handleConfirm() {
    const shopUrl = `https://saysky${this.selectedLanguage?.shop}${this.currentPath}?sc=${this.selectedCountry?.code}&sl=${this.selectedLanguage?.code}`;

    console.log(`Redirecting to: ${shopUrl}. Selected country: ${this.selectedCountry?.label}. Selected language: ${this.selectedLanguage?.label}`);

    this.hide();
    localStorage.setItem('COUNTRY_CHECKED_2025', 'true');
    localStorage.setItem('COUNTRY_SELECTED', this.selectedCountry?.code);
    localStorage.setItem('LANGUAGE_SELECTED', this.selectedLanguage?.code);

    this.setCountryFlagAndText();
    if (this.selectedLanguage?.market === this.storeCode || window.location.href.includes(shopUrl)) {
      return;
    }

    window.location.href = shopUrl;
  }

  setCountryFlagAndText() {
    const countryCode = localStorage.getItem('COUNTRY_SELECTED');
    const languageCode = localStorage.getItem('LANGUAGE_SELECTED');
    const country = this.countries.find((c) => c.code === countryCode);
    const language = country?.languages.find((l) => l.code === languageCode);

    const countryImgElements = document.querySelectorAll('.Popover__Value-flag img');    

    if (countryImgElements && countryCode) {
      const imgUrl = `https://cdn.shopify.com/static/images/flags/${countryCode.toLowerCase()}.svg?width=40`;

      countryImgElements.forEach(img => {
        console.log(`Updating img src to ${imgUrl}`);
        img.src = imgUrl;
        img.srcset = imgUrl;
        img.style.opacity = '1';
      });
    }

    const shopSwitcherTextElements = document.querySelectorAll('.shop-switcher-current-title');
    if (shopSwitcherTextElements && country && language) {
      shopSwitcherTextElements.forEach(text => {
        text.textContent = `${country.label} (${language?.label})`;
      });
    }

    if(countryImgElements) {
      countryImgElements.forEach(img => {
        img.style.opacity = '1';
      });
    }
  }

  handleOverlayClick() {
    this.hide();
    localStorage.setItem('COUNTRY_CHECKED_2025', 'true');
  }

  handleShowCountryClick(event) {
    const triggerElement = event.target.closest('[data-show-country]');
    if (triggerElement) {
      event.preventDefault();
      this.show();
    }
  }

  setTriggersExpanded(expanded) {
    document.querySelectorAll('[data-show-country]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(expanded));
    });
  }

  show() {
    if (this.popUp) {
      this.popUp.classList.add('is-visible');
    }
    if (this.pageOverlay) {
      this.pageOverlay.classList.add('is-visible');
    }
    this.setTriggersExpanded(true);
    document.body.style.top = '-' + window.scrollY + 'px';
    document.body.classList.add('modal-open');
  }

  hide() {
    if (this.popUp) {
      this.popUp.classList.remove('is-visible');
    }
    if (this.pageOverlay) {
      this.pageOverlay.classList.remove('is-visible');
    }
    this.setTriggersExpanded(false);
    var scrollY = document.body.style.top;
    document.body.classList.remove('modal-open');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  shouldShowPopup(detectedCountryCode) {
    const countryCodes = ['DK', 'SE', 'NO', 'DE', 'FR', 'UK', 'GB', 'US'];

    // if the referer is from saysky dont show the popup
    if (document.referrer.includes('saysky.')) {
      return false;
    }

    // If the detected country code is not in the list of country codes, and the country is the COM, dont show
    if (!countryCodes.includes(detectedCountryCode) && this.storeCode === 'COM') {
      return false;
    }

    // If the detected country code does not match the website's country code, show the popup
    if (detectedCountryCode !== this.storeCode) {
      return true;
    }

    return false;
  }

  populateCountrySelect() {
    if (!this.countrySelect) return;

    let html = '';
    this.countries.forEach((country) => {
      html += `<option value="${country.code}" ${this.selectedCountry?.code === country.code ? 'selected' : ''}>${
        country.label
      }</option>`;
    });
    this.countrySelect.innerHTML = html;
  }

  populateLanguageSelect(countryCode) {
    if (!this.languageSelect) return;

    const country = this.countries.find((c) => c.code === countryCode);
    if (!country) return;

    let html = '';
    country.languages.forEach((language) => {
      html += `<option value="${language.code}" ${this.selectedLanguage?.code === language.code ? 'selected' : ''}>${
        language.label
      }</option>`;
    });
    this.languageSelect.innerHTML = html;
  }

  updateSelectorDisplayText() {
    if (this.countrySelectText) {
      this.countrySelectText.textContent = this.selectedCountry?.label || 'Select your country';
    }
    if (this.languageSelectText) {
      this.languageSelectText.textContent = this.selectedLanguage?.label || 'Select your language';
    }
  }


  checkRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const sc = urlParams.get('sc');
    const sl = urlParams.get('sl');

    if (!sc && !sl) {
      return;
    }

    this.selectedCountry = this.countries.find((c) => c.code === sc);

    if (this.selectedCountry) {
      this.selectedLanguage = this.selectedCountry?.languages.find((l) => l.code === sl);
      this.continueButton?.classList.add('active');
    }

    if (this.selectedCountry && this.selectedLanguage) {
      console.log(`Received redirect and updated country and language. Selected country: ${this.selectedCountry?.label}. Selected language: ${this.selectedLanguage?.label}`);
      
      localStorage.setItem('COUNTRY_CHECKED_2025', 'true');
      localStorage.setItem('COUNTRY_SELECTED', this.selectedCountry?.code);
      localStorage.setItem('LANGUAGE_SELECTED', this.selectedLanguage?.code);

      this.updateSelectorDisplayText();
      this.setCountryFlagAndText();
    }
  }

  checkGeolocation() {
    if (localStorage.getItem('COUNTRY_CHECKED_2025') !== 'true') {
      if (window.Shopify.designMode !== true) {
        fetch('https://ipapi.co/json/')
          .then((response) => response.json())
          .then((data) => {
            const detectedCountryCode = data.country;

            if (this.shouldShowPopup(detectedCountryCode)) {
              setTimeout(() => {
                this.show();
              }, 450);
            } else {
              localStorage.setItem('COUNTRY_CHECKED_2025', 'true');
            }
          })
          .catch(() => {
            // If geolocation fails, don't show popup
            localStorage.setItem('COUNTRY_CHECKED_2025', 'true');
          });
      }
    }
  }
}

// Initialize Country Selector when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CountrySelector();
});

// Copy gender filter parameters to collection sub-navigation links on sale pages
(function() {
  function copyGenderFiltersToSubNavLinks() {
    // Check if we're on a sale collection page
    if (!window.location.pathname.includes('collections')) {
      return;
    }

    // Get all gender filter parameters from current URL
    const currentUrl = new URL(window.location.href);
    const genderFilters = currentUrl.searchParams.getAll('filter.p.m.custom.gender');
    
    // If no gender filters exist, nothing to do
    if (genderFilters.length === 0) {
      return;
    }

    // Find all sub-navigation links
    const subNavLinks = document.querySelectorAll('.collection-item__handle');
    
    subNavLinks.forEach(link => {
      try {
        // Parse the link's href
        const linkUrl = new URL(link.href, window.location.origin);
        
        // Skip if the link already has gender filter parameters
        if (linkUrl.searchParams.has('filter.p.m.custom.gender')) {
          return;
        }
        
        // Add all gender filter parameters to the link
        genderFilters.forEach(genderValue => {
          linkUrl.searchParams.append('filter.p.m.custom.gender', genderValue);
        });
        
        // Update the link's href
        link.href = linkUrl.pathname + linkUrl.search;
      } catch (error) {
        console.error('Error updating sub-navigation link:', error, link);
      }
    });
  }

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', copyGenderFiltersToSubNavLinks);
  
  // Also run after a short delay to handle dynamically loaded content
  setTimeout(copyGenderFiltersToSubNavLinks, 500);
  
  // Run on page load as well (for cases where DOMContentLoaded already fired)
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(copyGenderFiltersToSubNavLinks, 100);
  }
})();
